/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ActiveCommentsQuery",
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"CollabDraftWithRelevanceQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery",
	"bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadSpaceBlogCountQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"relay_BlogTreeRootComponentQuery",
	"relay_ContentHeaderUnifiedQuery",
	"relay_ContentTypesHeaderQuery",
	"relay_FooterCreateButtonsQuery",
	"relay_NotificationsButtonQuery",
	"relay_PersistentInviteEligibleQuery",
	"relay_ReactionsContentQuery",
	"relay_SpaceRestrictionCheckQuery",
	"relay_ThemeQuery",
	"relay_TopNavigationQuery",
	"relay_graphqlHelpersFetchMediaTokenQuery",
	"relay_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"relay_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"relay_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"relay_useIsUserViewingSpaceAsAnonQuery",
	"relay_useRegisterAdminAnnouncementBannerQuery",
	"relay_useShareAndRestrictButtonDataQuery",
	"relay_useTitleContentPropertiesForPublishedPageQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"rightPanel",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useConfluenceStandardToPremiumExperimentQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useFollowingFeedWithSortByStorageFeedContentQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePreloadCommentButtonQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useShortcutsSpaceNavigationQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "9a5f7b4effebffff5bebbfffffeb0200e0143ff7bccf07",
	"prod-apne2": "165f7b4effebfdff5bebbdffffff0300e074bff7bccf07",
	"prod-apse": "9adf7b3effebffff5bebbfffffff0200f01cbff7bddf07",
	"prod-apse2": "9eff7b5effebffffdfebbfffffff0300f076bff7bcff07",
	"prod-apsouth": "167f7b6effebffffdbebbfffffff0300e076bff7bcef07",
	"prod-cacentral": "1eff7b6effefffffdfebbfffffff0300e036bfffbcef07",
	"prod-east": "9edf7f3effefffffdfebbfffffff0300f0f4bfffbdff07",
	"prod-eucentral": "9edf7f5effeaffff5febbfffffff0300f074bff7bdff07",
	"prod-eucentral2": "8edf7b04ffeaffbf03abbdffffff0200e010bf73bccf07",
	"prod-euwest": "9edf7f3effefffffffebbfffffff0300f074bfffbdfb07",
	"prod-euwest2": "9eff7b7effefffffdfebbfffffff0300e076bff7bcef07",
	"prod-west2": "9edf7f9effefffffc3abbfffffff0300f078bfffbddf07",
	"stg-east": "3591730ef78e367f9beaffef375b432ce214ffff56cf06"
};

export const generatedAt: string | null = "2026-07-21T03:09:42.881Z";
